import { base64Convert } from "./base64ToCsv";

export const printBase64 = (base64, name)=>{
    
    const blob = base64Convert(base64);
    const url = window.URL.createObjectURL(blob);
    var link = document.createElement("a");
    link.setAttribute("href", url);
    link.setAttribute("download", name);
    document.body.appendChild(link);
    link.click();
}